'use client';

import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

const EmbeddedComponentBorderContext = createContext({
  enableBorder: false,
  handleEnableBorderChange: () => {},
});

export const useEmbeddedComponentBorder = () => {
  return useContext(EmbeddedComponentBorderContext);
};

export const EmbeddedComponentBorderProvider = ({ children }) => {
  const localWindow = typeof window !== 'undefined' ? window : null;

  const [enableBorder, setEnableBorder] = useState(
    Boolean(Number(localWindow?.localStorage.getItem('enableBorder')))
  );

  const handleEnableBorderChange = useCallback(
    (enableBorder) => {
      if (!localWindow) {
        return;
      }

      if (enableBorder) {
        localWindow.localStorage.setItem('enableBorder', '1');
        setEnableBorder(true);
      } else {
        localWindow.localStorage.setItem('enableBorder', '0');
        setEnableBorder(false);
      }
    },
    [localWindow]
  );

  useEffect(() => {
    const handleToggleBorder = (e) => {
      if (e.key === 'b' && e.metaKey && localWindow) {
        if (Number(localWindow.localStorage.getItem('enableBorder'))) {
          handleEnableBorderChange(false);
        } else {
          handleEnableBorderChange(true);
        }
      }
    };

    document.addEventListener('keydown', handleToggleBorder);
    return () => document.removeEventListener('keydown', handleToggleBorder);
  }, [handleEnableBorderChange, localWindow]);

  return (
    <EmbeddedComponentBorderContext.Provider
      value={{ enableBorder, handleEnableBorderChange }}
    >
      {children}
    </EmbeddedComponentBorderContext.Provider>
  );
}; 